import whitTheme from 'assets/theme/default';
import { useTenantColors } from 'hooks/useTenantColors';

// Overlay de theming por tenant: consume useTenantColors del
// TenantBrandingProvider y reaplica whitTheme con los colores del tenant.
//
// ConfigProvider anidado (externo = defaults en index.js, interno = este):
// en antd v5 el mas interno gana. Esto preserva el theme base para los
// componentes que se renderizan antes de que el branding termine de cargar
// (ej. pantalla de loading/error pre-auth).
const ThemedApp = ({ children }) => {
  const colors = useTenantColors();
  return whitTheme(children, colors);
};

export default ThemedApp;
